export default __webpack_public_path__ + "static/media/quoteApp.a3dc9261.jpg";